// Account Payable Payments Mutations

export const setPaymentList = (state, payload) => {
  state.paymentList = payload
}

export const setPaymentInfo = (state, payload) => {
  state.paymentInfo = payload
}
